import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Tag from '../tag'
import { getDataset } from '../utils'

import './index.scss'

const getTags = (tags = [], onDelete, readOnly, disabled, labelRemove) =>
  tags.map((tag) => {
    const { _id, label, tagClassName, dataset, tagLabel, parent, parentParent } = tag
    return (
      <li className={['tag-item', tagClassName].filter(Boolean).join(' ')} key={`tag-item-${_id}`} {...getDataset(dataset)}>
        <Tag
          label={tagLabel || label}
          id={_id}
          parent={parent}
          parentParent={parentParent}
          onDelete={onDelete}
          readOnly={readOnly}
          disabled={disabled || tag.disabled}
          labelRemove={labelRemove}
        />
      </li>
    )
  })

class Tags extends PureComponent {
  static propTypes = {
    tags: PropTypes.array,
    onTagRemove: PropTypes.func,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    texts: PropTypes.object,
    children: PropTypes.node
  }

  render() {
    const { tags, onTagRemove, texts = {}, disabled, readOnly, children } = this.props
    const lastItem = children || <span className="placeholder">{texts.placeholder || 'Choose...'}</span>

    return (
      <ul className="tag-list">
        {getTags(tags, onTagRemove, readOnly, disabled, texts.labelRemove)}
        <li className="tag-item" data-cy={'choose-input'}>{lastItem}</li>
      </ul>
    )
  }
}

export default Tags
